<div class="host-manual-order">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "word.house" | translate }}
      <!-- Properties -->
    </div>

    @if (listOfHouse?.length) {
      @for (house of listOfHouse; track house.house_id) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <div
                class="ant-select ant-select-show-arrow ant-select-single ant-select-lg overflow-hidden w-[330px]"
                (click)="displayPickerModal(house)">
                <div class="ant-select-selector">
                  <span class="ant-select-selection-item" [attr.title]="house.input_text">
                    {{ house.input_text }}
                  </span>
                  <div class="ant-select-arrow">
                    <i nz-icon nzType="down" nzTheme="outline"></i>
                  </div>
                </div>
              </div>
              <div class="ml-2 mr-2 flex-1">
                <input
                  nz-input
                  nzSize="large"
                  type="number"
                  [attr.placeholder]="'component.sidebar.db.placeholder.house_fee' | translate"
                  [(ngModel)]="house.price" />
              </div>
              <i
                *ngIf="listOfHouse.length > 1"
                class="delete pointer"
                nz-icon
                nzType="minus-circle"
                nzTheme="fill"
                (click)="removeHouseItem(house)"></i>
            </div>
          </div>
        </div>
      }
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <a nz-button nzType="link" nzSize="small" (click)="displayPickerModal()"
              >+ {{ "order.add_house" | translate }}</a
            >
          </div>
        </div>
      </div>
    } @else {
      <div class="v4-layout-field">
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <div
              class="ant-select ant-select-show-arrow ant-select-single ant-select-lg w-[330px]"
              (click)="displayPickerModal()">
              <div class="ant-select-selector">
                <span class="ant-select-selection-placeholder">
                  {{ "word.house_singular" | translate }}
                  <!-- Property  -->
                </span>
                <div class="ant-select-arrow">
                  <i nz-icon nzType="down" nzTheme="outline"></i>
                </div>
              </div>
            </div>
            <div class="ml-2 mr-2 flex-1">
              <input
                nz-input
                nzSize="large"
                type="number"
                [attr.placeholder]="'component.sidebar.db.placeholder.house_fee' | translate" />
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <ng-container [formGroup]="form">
    <div class="v4-layout-form mt-9">
      <div class="v4-layout-form-title">
        {{ "component.sidebar.order_form_title_info" | translate }}
        <!-- 基础信息 -->
      </div>
      <div class="v4-layout-field">
        <span class="v4-layout-field-label require">
          {{ "component.sidebar.order_form_item_customer" | translate }}
          <!-- 房客 -->
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <host-input-with-error
              class="w-full"
              [showError]="checking && invalid(form.get('name').value)"
              [errorText]="'请输入姓名'"
              [i18nErrorKey]="'errorText.name'">
              <input
                nz-input
                nzSize="large"
                formControlName="name"
                [readonly]="isExistedGuest"
                [attr.placeholder]="'placeholder.tenant_name' | translate"
                (compositionstart)="compositionstart('name')"
                (compositionend)="compositionend('name')"
                (input)="checkIfHasDuplicateGuest('name')" />
              <span
                class="guest-icon extra-icon"
                [class.highlight]="hasDuplicateGuest"
                (click)="displayDuplicateGuestModal()">
                <!-- <i nz-icon nzType="user" nzTheme="outline"></i> -->
              </span>
            </host-input-with-error>
          </div>
          <!-- <div class="error-tip">请输入姓名</div> -->
        </div>
      </div>
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "component.sidebar.order_form_item_mobile" | translate }}
          <!-- 手机号 -->
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            @if (isInternational) {
              <div class="mr-[8px]">
                <nz-select
                  #codeSearch
                  class="w-[90px]"
                  nzSize="large"
                  nzShowSearch
                  [(ngModel)]="countryCode"
                  (nzBlur)="onSearchBlur(codeSearch)"
                  [ngModelOptions]="{ standalone: true }"
                  [nzOptions]="listOfCountryCode"
                  [nzDropdownMatchSelectWidth]="false">
                </nz-select>
              </div>
            }
            <input
              nz-input
              nzSize="large"
              type="phone"
              class="flex-1"
              formControlName="mobile"
              [readonly]="isExistedGuest"
              [maxLength]="50"
              [attr.placeholder]="'placeholder.mobile_optional' | translate"
              (compositionstart)="compositionstart('mobile')"
              (compositionend)="compositionend('mobile')"
              (input)="checkIfHasDuplicateGuest('mobile')" />

            <span
              class="guest-icon extra-icon"
              [class.highlight]="hasDuplicateGuest"
              (click)="displayDuplicateGuestModal()">
              <!-- <i nz-icon nzType="user" nzTheme="outline"></i> -->
            </span>
          </div>
        </div>
      </div>

      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "word.email" | translate }}
          <!-- 邮箱 -->
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <input
              nz-input
              nzSize="large"
              type="phone"
              class="w-full"
              formControlName="email"
              [readonly]="isExistedGuest"
              [maxLength]="50"
              [attr.placeholder]="'placeholder.email_optional' | translate"
              (compositionstart)="compositionstart('email')"
              (compositionend)="compositionend('email')"
              (input)="checkIfHasDuplicateGuest('email')" />

            <span
              class="guest-icon extra-icon"
              [class.highlight]="hasDuplicateGuest"
              (click)="displayDuplicateGuestModal()">
              <!-- <i nz-icon nzType="user" nzTheme="outline"></i> -->
            </span>
          </div>
        </div>
      </div>

      <div class="v4-layout-field">
        <span class="v4-layout-field-label require">
          {{ "component.sidebar.order_form_item_channel" | translate }}
          <!-- 来源 -->
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <host-input-with-error
              class="w-full"
              [errorText]="'请选择来源渠道'"
              [i18nErrorKey]="'placeholder.channel'"
              [showError]="checking && invalid(form.get('channel').value)">
              <nz-select
                class="w-full"
                nzSize="large"
                formControlName="channel"
                [nzPlaceHolder]="'placeholder.siderbar.order_channel' | translate"
                [nzOptions]="listOfChannels">
              </nz-select>
            </host-input-with-error>
          </div>
        </div>
      </div>

      <div class="v4-layout-field">
        <div class="v4-layout-field-label">{{ "operate-sidebar-manual-order_html_number_of_guest" | translate }}</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <v4-guest-select class="w-full" size="large" formControlName="guests"></v4-guest-select>
          </div>
        </div>
      </div>

      <div class="v4-layout-field">
        <span class="v4-layout-field-label">
          {{ "component.sidebar.order_form_item_commission" | translate }}
          <!-- 佣金 -->
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <input
              nz-input
              nzSize="large"
              type="number"
              class="w-full"
              formControlName="commission"
              [attr.placeholder]="'placeholder.amount_optional' | translate"
              min="0"
              [max]="999999999"
              step="1"
              precision="2" />
            <span
              class="calculator-icon extra-icon"
              (click)="displayCommissionRateMenu = !displayCommissionRateMenu"></span>
            <div class="calculate-wrapper" *ngIf="displayCommissionRateMenu">
              <ng-template [ngTemplateOutlet]="calculateMenu"></ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">
          {{ "component.sidebar.order_form_item_currency" | translate }}
          <!-- 币种 -->
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select class="w-full" nzSize="large" formControlName="currency_type" [nzOptions]="listOfCurrency">
            </nz-select>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-form" *ngIf="totalHouseFee && totalHouseFee !== '-'">
      <div class="v4-layout-form-title">
        {{ "component.sidebar.order_form_title_collection" | translate }}
        <!-- 收款 -->
      </div>
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">
          {{ "component.sidebar.order_form_item_collected_fee" | translate }}
          <!-- 已收房款 -->
        </span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <input
              #paidAmount
              nz-input
              nzSize="large"
              type="number"
              formControlName="paid_amount"
              [attr.placeholder]="'component.sidebar.db.placeholder.received' | translate"
              (focus)="onInputFocus()" />
          </div>
        </div>
      </div>
      <div class="v4-layout-field" *ngIf="form.get('paid_amount').value > 0">
        <span class="v4-layout-field-label require">
          {{ "component.sidebar.order_form_item_payment_method" | translate }}
          <!-- 交易方式 -->
        </span>
        <div class="v4-layout-field-control" [class.has-error]="checking && invalid(form.get('payment_method').value)">
          <div class="v4-layout-field-row">
            <host-input-with-error
              class="w-full"
              [showError]="checking && invalid(form.get('payment_method').value)"
              [errorText]="'请选择交易方式'"
              [i18nErrorKey]="'placeholder.siderbar.payment_method'">
              <nz-select
                class="w-full"
                nzSize="large"
                [nzPlaceHolder]="'placeholder.siderbar.payment_method' | translate"
                formControlName="payment_method"
                [nzOptions]="listOfIncomeMethod">
              </nz-select>
            </host-input-with-error>
          </div>
        </div>
      </div>
    </div>

    <div class="v4-layout-form">
      <ng-container *ngIf="noteStatus === 'none'">
        <div class="v4-layout-field">
          <a nz-button nzType="link" nzSize="small" (click)="noteStatus = 'editing'">
            + {{ "component.sidebar.order_form_item_add_mark" | translate }}
            <!-- +添加订单备注 -->
          </a>
        </div>
      </ng-container>
      <ng-container *ngIf="noteStatus === 'editing'">
        <div class="v4-layout-form-title flex flex-row justify-between items-center">
          {{ "component.sidebar.order_form_title_mark" | translate }}
          <!-- 订单备注 -->
          <a nz-button nzType="link" class="no-style" (click)="noteStatus = 'none'">
            {{ "word.cancel" | translate }}
            <!-- 取消 -->
          </a>
        </div>
        <div class="v4-layout-field">
          <div class="v4-layout-field-control">
            <textarea
              class="row-input"
              nz-input
              formControlName="note"
              [attr.placeholder]="'placeholder.input_remarks' | translate"
              rows="4"></textarea>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <footer class="bar-footer">
    <button class="mr-3" nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzType="primary" nzSize="large" (click)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>

<ng-template #calculateMenu>
  <div class="menu-container">
    <div class="inputs">
      <nz-input-group nzSuffix="%">
        <input
          type="number"
          nz-input
          [(ngModel)]="commissionRate"
          min="0"
          max="100"
          [attr.placeholder]="'placeholder.sidebar.commission_rate' | translate"
          hostAutoFocus />
      </nz-input-group>
      <button nz-button nzType="primary" (click)="onCompleteCommissionRate()">
        {{ "word.confirm" | translate }}
      </button>
    </div>
    <div class="defaults">
      <div class="default-tag" *ngFor="let rate of listOfCommissionRate">
        <span class="tag-rate-text" (click)="onSelectCommissionRate(rate)">{{ rate }}%</span>
        <i class="tag-rate-delete" nz-icon nzType="close" nzTheme="outline" (click)="onDeleteCommissionRate(rate)"></i>
      </div>
    </div>
  </div>
</ng-template>
